export const slugify = (url: string) => {
    return url.trim().toLowerCase().replace(/\s+/g, '-');
};
